import request from '../utils/request'

// 资质是否必传 
export function getPropertyByPar(code) {
  return request({
    url: '/shop/basic/getPropertyByPar?shopCode=' + code,
    method: 'get',
    data: {}
  })
}

// 所有图片上传
export function upload(data) {
  return request({
    url: '/file/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  })
}


// 小程序-图片上传
export function wechatUpload(data) {
  return request({
    url: '/shop/WxShopApplets/uploadFile',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  })
}

// 营业执照OCR验证
export function licenseOcrAuth(url) {
  return request({
    url: '/sdk/Ocr/OcrApi/?url=' + url,
    method: 'get',
    data: {}
  })
}

// 身份证OCR验证
export function idcardOcrAuth(data) {
  return request({
    url: '/sdk/Ocr/idcard?url='+data.url+'&side='+data.side,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'get'
  })
}

// 银行卡OCR验证
export function bankcardOcrAuth(data) {
  return request({
    url: '/sdk/Ocr/bankcardByUrl?url='+data.url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'get'
  })
}

// 提交-基本信息认证
export function updateShopAuth(data) {
  return request({
    url: '/shop/check/updateShopAuth',
    method: 'post',
    data: data
  })
}


// 地图
// https://m.amap.com/picker/?keywords=parameter1&amp;zoom=parameter2&amp;center=parameter3&amp;radius=parameter4&amp;total=parameter5&amp;key=parameter6
//m.amap.com/picker/?keywords=写字楼,小区,学校&zoom=15&center=116.470098,39.992838&radius=1000&total=20&key=（您的Key）



// WEBPACK FOOTER //
// ./src/api/auth.js